// extracted by mini-css-extract-plugin
module.exports = {"Modal":"modal_Modal__2vl7m","TextModal":"modal_TextModal__1Omp5","ButtonModal":"modal_ButtonModal__NISDs","ButtonOK":"modal_ButtonOK__1Ek_6"};